import React from 'react';
import propTypes from 'prop-types';
import actions from '@ion/api/audit-logs/actions';

import { ActionChip } from '@metarouter-private/mr-mui';

import { actionColor } from './color-coding';
import { readableAction } from 'app/audit-logs/actions';

export default function ActionCell({ action }) {
  return <ActionChip data-test-id="auditLogActionCell" color={actionColor(action)} label={readableAction(action)} />;
}

ActionCell.propTypes = {
  action: propTypes.oneOf(Object.values(actions)),
};
